export default __webpack_public_path__ + "static/media/homeHeaderBanner.18b00ea8.png";